import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const ViewSelectorContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
  background: #f8f9fa;
  border-radius: 12px;
  padding: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 768px) {
    margin-bottom: 1rem;
    max-width: 350px;
    padding: 0.4rem;
  }

  @media (max-width: 480px) {
    margin-bottom: 0.75rem;
    max-width: 100%;
    padding: 0.3rem;
    border-radius: 10px;
  }
`;

const ViewButton = styled.button`
  flex: 1;
  padding: 1rem 2rem;
  border: none;
  background: ${props => props.active ? '#007bff' : 'transparent'};
  color: ${props => props.active ? 'white' : '#6c757d'};
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  &:hover {
    background: ${props => props.active ? '#0056b3' : '#e9ecef'};
    color: ${props => props.active ? 'white' : '#495057'};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
  }

  @media (max-width: 768px) {
    padding: 0.75rem 1rem;
    font-size: 0.9rem;
  }

  @media (max-width: 480px) {
    padding: 0.5rem 0.75rem;
    font-size: 0.8rem;
  }
`;

const ViewIcon = styled.span`
  font-size: 1.2rem;
`;

const ViewLabel = styled.span`
  @media (max-width: 768px) {
    display: none;
  }
`;

const BodyViewSelector = ({ currentView, onViewChange }) => {
  const { t } = useTranslation();
  return (
    <ViewSelectorContainer>
      <ViewButton
        active={currentView === 'front'}
        onClick={() => onViewChange('front')}
      >
        <ViewIcon>👤</ViewIcon>
        <ViewLabel>{t('bodyDiagram.view.front')}</ViewLabel>
      </ViewButton>
      <ViewButton
        active={currentView === 'back'}
        onClick={() => onViewChange('back')}
      >
        <ViewIcon>👥</ViewIcon>
        <ViewLabel>{t('bodyDiagram.view.back')}</ViewLabel>
      </ViewButton>
    </ViewSelectorContainer>
  );
};

export default BodyViewSelector;
